import clsx from 'clsx';
import React from 'react';

type Props = {
  className?: string;
  progress: number; // Optional prop to set the progress percentage
};
/**
 * @param progress is the progress percentage to be displayed in the progress bar. between 0 and 100.
 * @param className is the className to be applied to the progress bar wrapper.
 */
export default function ProgressBar({ className = '', progress = 100 }: Props) {
  const wrapperStyle = clsx(
    'dark:border bg-gray-200 dark:bg-background-accent h-2 flex-1 rounded-full overflow-hidden'
  );
  return (
    <div className={`${className} flex items-center gap-2 py-2`}>
      <div className={wrapperStyle}>
        <div
          className="bg-primary h-full"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <small
        className={`font-semibold ${progress === 0 ? 'low-emphasis-text' : 'text-primary'}`}
      >{`${progress}%`}</small>
    </div>
  );
}
